'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _colors = require('material-ui/styles/colors');

var _style = require('../../../style/');

var _util = require('@its/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var icon = {
  height: '100px',
  width: '100px'
};

var grey = {
  color: _colors.grey600
};

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var Icon = this.props.icon;
      var containerStyle = this.props.containerStyle;

      return _react2.default.createElement(
        'div',
        { style: containerStyle ? (0, _util.merge)(_style.center, containerStyle) : _style.center },
        _react2.default.createElement(Icon, {
          color: _colors.grey400,
          style: icon
        }),
        _react2.default.createElement('br', null),
        !this.props.onlyIcon ? _react2.default.createElement(
          _Paper2.default,
          { zDepth: 0, style: grey },
          this.props.children
        ) : undefined
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  icon: _react2.default.PropTypes.func.isRequired,
  children: _react2.default.PropTypes.any,
  onlyIcon: _react2.default.PropTypes.bool,
  containerStyle: _react2.default.PropTypes.object
};
_class.defaultProps = {
  onlyIcon: false
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Pages/IconPage/IconPage.js
 ** module id = 113
 ** module chunks = 0
 **/